var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParaguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.24248 0 3.13173 2.76867 1.19073 6.78263H22.8092C20.8683 2.76867 16.7575 0 12 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C16.7575 24 20.8683 21.2313 22.8093 17.2174H1.19073C3.13173 21.2313 7.24248 24 12 24Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9514 8.52689L13.8446 9.63365C14.3167 10.1057 14.6088 10.7579 14.6088 11.4783C14.6088 12.919 13.4408 14.087 12.0001 14.087C10.5594 14.087 9.39138 12.919 9.39138 11.4783C9.39138 10.7579 9.68341 10.1057 10.1555 9.63365L9.04872 8.52689C8.29333 9.28214 7.82617 10.3256 7.82617 11.4783C7.82617 13.7835 9.69489 15.6522 12.0001 15.6522C14.3052 15.6522 16.174 13.7834 16.174 11.4783C16.1739 10.3256 15.7068 9.28214 14.9514 8.52689Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.91302L12.3886 11.1088H13.6458L12.6287 11.8477L13.0172 13.0435L12 12.3045L10.9828 13.0435L11.3714 11.8477L10.3542 11.1088H11.6115L12 9.91302Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6492"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParaguay);
export default __webpack_public_path__ + "static/media/paraguay.a5678383297a51e2587fd9c20219cc24.svg";
export { ForwardRef as ReactComponent };